import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import enLocale from "../locales/en.json";

export const defaultLng = "en";

export const resources = {
  en: {
    translation: enLocale,
  },
} as const;

i18next.use(initReactI18next).init({
  lng: defaultLng,
  //   debug: true,
  fallbackLng: defaultLng,
  resources,

  // if you see an error like: "Argument of type 'DefaultTFuncReturn' is not assignable to parameter of type xyz"
  // set returnNull to false (and also in the i18next.d.ts options)
  // returnNull: false,
});

export default i18next;
